import React, { useContext } from "react";
import { useThread } from "../context/ThreadContext";
import { BorderBeam } from "./BorderBeam";
import { AuthContext } from "../context/AuthContext";

const NewChat = () => {
  const { dispatch } = useThread();

  const handleNewChat = () => {
    dispatch({ type: 'SET_CURRENT_THREAD', payload: null });
  };

  const { theme } = useContext(AuthContext);

  return (
    <div className="sideMenuButton relative" onClick={handleNewChat}>
      <BorderBeam
        size={200}
        duration={8}
        colorFrom={theme === "light" ? "#565869" : "#565869"}
        colorTo={theme === "light" ? "#2d2d3a" : "#2d2d3a"}
        style={{
          zIndex: 1,
          opacity: theme === "light" ? 0.1 : 1,
          mixBlendMode: "normal",
        }}
      />
      <span>+</span>
      New chat
    </div>
  );
};

export default NewChat;
